import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';

export class Main extends Component {
    displayName = Main.name

    render() {
        return (
                <div className='container' id='mainContainer1'>
                    <h2>Acervo de Información de Interés Nacional</h2>
                    <p>El Acervo incluye para su consulta Metodologías, especificaciones concretas en su aplicación y Metadatos
                    utilizados para generar la Información considerada de Interés Nacional
                    </p>
                    <Grid bsClass="">
                       <Row className="show-grid">
                         <Col xs={6} sm={6} md={6}>
                            <p  className='Enc2'>Tipo de consulta</p>
                            <p className='Celda1'>
                                  1.- Metodologías, especificaciones concretas en su aplicación y Metadatos utilizados en
                                  la generación de la
                                  Información de Interés Nacional
                                  A PARTIR de la entrada en vigor de la Ley del SNIEG
                                  <br />
                                  <br />
                                  <br />
                              </p>
                              <p style={{textAlign:'center'}}><Link to='/Subsistemas/2' >Consulta</Link></p>


                        </Col>
                        <Col xs={6} sm={6} md={6}>
                          <p  className='Enc2'>Fundamento Legal (Ley del SNIEG)</p>
                          <p className='Celda1'>
                              Artículo 3.- El Sistema Nacional de Información Estadística y Geográfica, tiene la finalidad de suministrar a la sociedad
                              y al Estado Información de calidad, pertinente, veraz y oportuna, a efecto de coadyuvar al desarrollo nacional.
                          <br />
                          <br />
                          Serán principios rectores del SNIEG los de accesibilidad, transparencia, objetividad e independencia.
                          </p>
                        </Col>
                      </Row>
                       <Row className="show-grid">
                         <Col xs={6} sm={6} md={6} lgHidden mdHidden smHidden xsHidden>
                            <p  className='Enc2'>Tipo de consulta</p>
                        </Col>

                        <Col xs={6} sm={6} md={6}>
                          <p className='Celda1'>2.- Metodologías utilizadas ANTES de la entrada en vigor de la Ley del SNIEG
                              <br />
                              <br />
                              <br />
                              <br />

                            </p>
                              <p style={{textAlign:'center'}}><Link to='/Subsistemas/1' >Consulta</Link></p>
                        </Col>
                        <Col xs={6} sm={6} md={6} lgHidden mdHidden smHidden xsHidden>
                          <p  className='Enc2'>Fundamento Legal (Ley del SNIEG)</p>
                        </Col>
                        <Col xs={6} sm={6} md={6}>
                          <p className='Celda1'><span style={{ fontWeight: "bold" }}> Artículo décimo tercero transitorio</span>.- La Junta de Gobierno contará con un plazo de ciento
                          ochenta días, contados a partir de la designación de sus primeros miembros, para: determinar
                          aquella información que formará parte del Acervo de Información Estadística y Geográfica a
                          que se refiere el Título Tercero, Capítulo III de esta Ley, y hacer del conocimiento del
                          público, a través de internet, las metodologías que hasta antes de la entrada en vigor de la
                          presente ley se hubieren utilizado para la producción de dicha información.</p>
                        </Col>
                      </Row>
                </Grid>
            </div>
        );
    }
}
